// Library methods
import React from "react";

// MUI Components
import { Grid, Typography } from "@mui/material";

// Utilities
import styles from "./index.module.css";

const PelliRobson = ({ examData }) => {
  const letters = examData?.state?.letters ?? [];
  const displayedLetters = letters.flatMap((letter) =>
    letter.letters.map((char) => ({
      color:
        char?.State === "GuessedCorrectly"
          ? "#13A321"
          : char?.State === "Skipped"
            ? "#202338"
            : char?.State === "None"
              ? "#202338"
              : "#B21515",
      backgroundImage:
        char?.State === "Skipped"
          ? "linear-gradient(0deg, #E7C43C60 25%, #FFF 25%, #FFF 50%, #E7C43C60 50%, #E7C43C60 75%, #FFF 75%, #FFF 100%)"
          : "none",
      backgroundSize: "8px 8px",
      value: char?.Value,
    }))
  );

  return (
    <Grid className={styles.gridContainer}>
      {letters?.length > 0 &&
        displayedLetters.map((letter, index) => {
          return (
            <Grid
              item
              key={index}
              className={styles.gridItem}
              sx={{
                backgroundImage: letter?.backgroundImage,
                backgroundSize: letter?.backgroundSize,
                display: "flex",
                justifyContent: "center",
                height: "32px",
                width: "32px",
              }}
            >
              <Typography
                variant="h5"
                color={letter.color}
                fontWeight={500}
                fontSize="20px"
              >
                {letter.value}
              </Typography>
            </Grid>
          );
        })}
    </Grid>
  );
};

export default PelliRobson;
